// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"45":"d1501b94","551":"09529b3e"}[chunkId] + ".chunk.css";
};